export default {
  namespaced: true,
  state: {
    // Estado global para flujo de solicitud
    salario_propuesto: null,
    listadoPersonasDesdeBackend: false,
    es_central: false,
    solicitud: null,
    faseActual: null,
    esFaseActivaUsuario: false,
    idEstadoFaseActiva: false,
    mostrarCandidatosBolson: false,
    candidatosBolsonSeleccionadosCount: 0,
    candidatosBolsonSeleccionados: [],
    esUsuario: {
      esTitular: false,
      esUFI: false,
      esRRHH: false,
    },
    // Cargar idDelegadoEmpleadoPuesto desde localStorage si existe
    idDelegadoEmpleadoPuesto: localStorage.getItem("idDelegadoEmpleadoPuesto")
      ? Number.parseInt(localStorage.getItem("idDelegadoEmpleadoPuesto"))
      : null,
    fases: {
      UNIDAD: 1,
      RRHH: 2,
      UFI: 3,
      DESPACHO: 4,
    },
    // Códigos de fases por módulo para validaciones de UI
    fasesRh: ["P13-F3", "P14-F2", "P15-F3", "P14-F5", "P15-F5"],
    fasesUnidad: ["P13-F1", "P14-F1", "P15-F1"],
    faseID: {
      1: "Borrador",
      2: "Completado",
      3: "A solventar",
      4: "Pendiente",
      5: "Rechazado",
      6: "Observado",
      7: "Aprobado",
    },
    contratacionDirecta: {
      id: null,
      destino: {},
      personas: [],
      id_tipo_contratacion: null,
      sistem_pago: {},
      id_plaza_seleccionada: null,
      cuadro_aportaciones: {},
      cifrado: null,
      unidad: null,
      id_unidad_destino: null,
      id_unidad_secundaria: null,
    },
    personaProcesoEditando: null,
    // Cargar tabOrigen desde localStorage si existe
    tabOrigen: localStorage.getItem("tabOrigen")
      ? Number.parseInt(localStorage.getItem("tabOrigen"))
      : null,
    // Flag de re-declinación dentro de una solicitud que ya viene de reaprobación
    // (P16-F3 / P19-F14). Scoping por id de solicitud. Persistido en localStorage
    // para sobrevivir al refresh. Se limpia cuando la fase avanza exitosamente.
    redeclinacionReaprobacionPorSolicitud: (() => {
      try {
        const raw = localStorage.getItem("redeclinacionReaprobacionPorSolicitud");
        return raw ? JSON.parse(raw) : {};
      } catch (e) {
        return {};
      }
    })(),
  },
  getters: {
    getFase: (state) => (fase) => state.fases[fase],
    getFaseID: (state) => (id) => state.faseID[id],
    getSalarioPropuesto: (state) => state.salario_propuesto,
    getEsUsuario: (state) => state.esUsuario,
    getEsCentral: (state) => state.es_central,
    huboRedeclinacionReaprobacionFor: (state) => (idSolicitud) =>
      !!state.redeclinacionReaprobacionPorSolicitud[idSolicitud],
  },
  mutations: {
    // Mutaciones para sincronizar datos de solicitud y fase
    SET_ES_CENTRAL(state, es_central) {
      state.es_central = es_central;
    },
    SET_LISTADO_PERSONAS_BACKEND(state, listadoPersonasDesdeBackend) {
      state.listadoPersonasDesdeBackend = listadoPersonasDesdeBackend;
    },
    SET_SOLICITUD(state, solicitud) {
      state.solicitud = solicitud;
    },
    SET_FASE_ACTUAL(state, faseActual) {
      state.faseActual = faseActual;
    },
    SET_ES_FASE_ACTIVA_USUARIO(state, esFaseActivaUsuario) {
      state.esFaseActivaUsuario = esFaseActivaUsuario;
    },
    SET_ESTADO_FASE_ACTIVA(state, idEstadoFaseActiva) {
      state.idEstadoFaseActiva = idEstadoFaseActiva;
    },
    SET_MOSTRAR_CANDIDATOS_BOLSON(state, payload) {
      state.mostrarCandidatosBolson = payload;
    },
    SET_CANDIDATOS_BOLSON_SELECCIONADOS_COUNT(state, count) {
      state.candidatosBolsonSeleccionadosCount = count;
    },
    SET_CANDIDATOS_BOLSON_SELECCIONADOS(state, list) {
      state.candidatosBolsonSeleccionados = list;
    },
    SET_SALARIO_PROPUESTO(state, salario) {
      state.salario_propuesto = salario;
    },
    SET_DELEGADO_EMPLEADO_PUESTO(state, idDelegadoEmpleadoPuesto) {
      state.idDelegadoEmpleadoPuesto = idDelegadoEmpleadoPuesto;
      // Persistir en localStorage
      if (
        idDelegadoEmpleadoPuesto !== null &&
        idDelegadoEmpleadoPuesto !== undefined
      ) {
        localStorage.setItem(
          "idDelegadoEmpleadoPuesto",
          idDelegadoEmpleadoPuesto
        );
      } else {
        localStorage.removeItem("idDelegadoEmpleadoPuesto");
      }
    },
    SET_ES_USUARIO(state, esUsuario) {
      state.esUsuario = esUsuario;
    },
    SET_CONTRATACION_DIRECTA(state, contratacionDirecta) {
      state.contratacionDirecta = {
        ...state.contratacionDirecta,
        ...contratacionDirecta,
      };
    },
    CLEAR_CONTRATACION_DIRECTA(state) {
      state.contratacionDirecta = null;
    },
    SET_PERSONA_PROCESO_EDITANDO(state, persona) {
      state.personaProcesoEditando = persona;
    },
    SET_TAB_ORIGEN(state, tabOrigen) {
      state.tabOrigen = tabOrigen;
      // Persistir en localStorage
      if (tabOrigen !== null && tabOrigen !== undefined) {
        localStorage.setItem("tabOrigen", tabOrigen);
      } else {
        localStorage.removeItem("tabOrigen");
      }
    },
    SET_REDECLINACION_REAPROBACION(state, { idSolicitud, valor }) {
      if (idSolicitud === null || idSolicitud === undefined) return;
      const key = String(idSolicitud);
      const next = { ...state.redeclinacionReaprobacionPorSolicitud };
      if (valor) {
        next[key] = true;
      } else {
        delete next[key];
      }
      state.redeclinacionReaprobacionPorSolicitud = next;
      try {
        localStorage.setItem(
          "redeclinacionReaprobacionPorSolicitud",
          JSON.stringify(next)
        );
      } catch (e) {
        // silencioso: si localStorage falla, solo perdemos la persistencia
      }
    },
  },
  actions: {
    setEsCentral({ commit }, es_central) {
      commit("SET_ES_CENTRAL", es_central);
    },
    setEsListadoPersonasBackend({ commit }, listadoPersonasDesdeBackend) {
      commit("SET_LISTADO_PERSONAS_BACKEND", listadoPersonasDesdeBackend);
    },
    setSolicitud({ commit }, solicitud) {
      commit("SET_SOLICITUD", solicitud);
    },
    setFaseActual({ commit }, faseActual) {
      commit("SET_FASE_ACTUAL", faseActual);
    },
    setEsFaseActivaUsuario({ commit }, esFaseActivaUsuario) {
      commit("SET_ES_FASE_ACTIVA_USUARIO", esFaseActivaUsuario);
    },
    setEstadoFaseActiva({ commit }, idEstadoFaseActiva) {
      commit("SET_ESTADO_FASE_ACTIVA", idEstadoFaseActiva);
    },
    setMostrarCandidatosBolson({ commit }, payload) {
      commit("SET_MOSTRAR_CANDIDATOS_BOLSON", payload);
    },
    setCandidatosBolsonSeleccionadosCount({ commit }, count) {
      commit("SET_CANDIDATOS_BOLSON_SELECCIONADOS_COUNT", count);
    },
    setCandidatosBolsonSeleccionados({ commit }, list) {
      commit("SET_CANDIDATOS_BOLSON_SELECCIONADOS", list);
    },
    setSalarioPropuesto({ commit }, salario) {
      commit("SET_SALARIO_PROPUESTO", salario);
    },
    setDelegadoEmpleadoPuesto({ commit }, idDelegadoEmpleadoPuesto) {
      commit("SET_DELEGADO_EMPLEADO_PUESTO", idDelegadoEmpleadoPuesto);
    },
    clearDelegadoEmpleadoPuesto({ commit }) {
      commit("SET_DELEGADO_EMPLEADO_PUESTO", null);
    },
    setEsUsuario({ commit }, esUsuario) {
      commit("SET_ES_USUARIO", esUsuario);
    },
    setContratacionDirecta({ commit }, contratacionDirecta) {
      commit("SET_CONTRATACION_DIRECTA", contratacionDirecta);
    },
    clearContratacionDirecta({ commit }) {
      commit("CLEAR_CONTRATACION_DIRECTA", {
        id: null,
        destino: {},
        personas: [],
        id_tipo_contratacion: null,
        sistem_pago: {},
        id_plaza_seleccionada: null,
        cuadro_aportaciones: {},
        cifrado: null,
        unidad: null,
        id_unidad_destino: null,
        id_unidad_secundaria: null,
      });
    },
    setPersonaProcesoEditando({ commit }, persona) {
      commit("SET_PERSONA_PROCESO_EDITANDO", persona);
    },
    setTabOrigen({ commit }, tabOrigen) {
      commit("SET_TAB_ORIGEN", tabOrigen);
    },
    setRedeclinacionReaprobacion({ commit }, { idSolicitud, valor }) {
      commit("SET_REDECLINACION_REAPROBACION", { idSolicitud, valor });
    },
    clearRedeclinacionReaprobacion({ commit }, idSolicitud) {
      commit("SET_REDECLINACION_REAPROBACION", { idSolicitud, valor: false });
    },
    resetSolicitudStates({ commit }) {
      commit("SET_SOLICITUD", null);
      commit("SET_FASE_ACTUAL", null);
      commit("SET_SALARIO_PROPUESTO", null);
      commit("SET_DELEGADO_EMPLEADO_PUESTO", null);
      commit("SET_CONTRATACION_DIRECTA", {
        id: null,
        destino: {},
        personas: [],
        id_tipo_contratacion: null,
        sistem_pago: {},
        id_plaza_seleccionada: null,
        cuadro_aportaciones: {},
        cifrado: null,
      });
      commit("SET_PERSONA_PROCESO_EDITANDO", null);
      commit("SET_TAB_ORIGEN", null);
      commit("SET_MOSTRAR_CANDIDATOS_BOLSON", false);
      commit("SET_ES_CENTRAL", false);
      commit("SET_CANDIDATOS_BOLSON_SELECCIONADOS_COUNT", 0);
      commit("SET_CANDIDATOS_BOLSON_SELECCIONADOS", []);
    },
  },
};
